export default __webpack_public_path__ + "static/media/va.381edf87.svg";